import { render } from "./sunglass.vue?vue&type=template&id=41c914a4"
import script from "./sunglass.vue?vue&type=script&lang=js"
export * from "./sunglass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__